// Generates a tailored low-voltage / technology scope for a pipeline project,
// based on unit count and housing type. This is a *recommendation* (not a quote)
// — it positions BUILDLAB as the expert and seeds the "get an exact scope" CTA.
export function scopeEstimate(p) {
    const units = p.totalUnits || 0;
    const type = (p.housingType || '').toLowerCase();
    const scope = ['Structured cabling', 'Building WiFi', 'IP surveillance', 'Door access'];
    if (units >= 50) scope.push('DAS / ERCCS');
    if (type.includes('senior') || type.includes('special')) scope.push('Emergency call');
    scope.push('Common-area AV');
    return scope;
}

export default scopeEstimate;
